import React from 'react';

const SecondSidebar = ({ children }) => {
    return (
        <aside className="w-[260px] bg-[#0f172a]/40 border-r border-slate-800/60 flex flex-col shadow-xl z-10 overflow-hidden shrink-0 backdrop-blur-md">
            <div className="flex-1 flex flex-col overflow-y-auto custom-scrollbar">
                {children}
            </div>
        </aside>
    );
};

export default SecondSidebar;
